
import config from "./config.js";

export const isDev = /* process.env.ENV==="dev" || */ false;
export const noCaptcha = true /* ?? !!isDev */;
export const infoCenter = {
  code:  config.centerCode,
  passCode: config.centerPassCode,
}